export default "__VITE_ASSET__IX175gvX__"